import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { Provider } from 'react-redux';
import { store } from './store';
import { ToastContainer } from 'react-toastify';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLISH_KEY!);

const appearance = {
  theme: 'stripe',

  variables: {
    colorPrimary: '#EA4459',
    colorBackground: '#F4F5F8',
    colorText: '#30313d',
    colorDanger: '#df1b41',
    fontFamily: 'Ideal Sans, system-ui, sans-serif',
    spacingUnit: '2px',
    borderRadius: '4px'
    // See all possible variables below
  }
};

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(
  // <React.StrictMode>
  <Provider store={store}>
    <Elements
      stripe={stripePromise}
      options={{
        appearance: {
          theme: 'flat',
          variables: {
            ...appearance.variables,
            spacingUnit: '4px'
          }
        }
      }}
    >
      <App />
    </Elements>
    <ToastContainer position="bottom-right" theme="light" />
  </Provider>
  // </React.StrictMode>
);
